export default {
  nav: {
    home: 'Home',
    items: 'Elementi',
    commonStations: 'Stazioni e sensori',
    commonStationsExplorer: 'Esplora stazioni',
    profile: 'Profilo',
  },
  common: {
    save: 'Salva',
    cancel: 'Annulla',
    delete: 'Elimina',
    edit: 'Modifica',
    create: 'Crea',
    loading: 'Caricamento...',
    error: 'Errore',
    success: 'Operazione completata',
    confirm: 'Conferma',
    back: 'Indietro',
    logout: 'Logout',
    login: 'Accedi',
  },
  item: {
    title: 'Elemento',
    titlePlural: 'Elementi',
    name: 'Nome',
    description: 'Descrizione',
    createdAt: 'Creato il',
    new: 'Nuovo elemento',
    deleteConfirm: 'Eliminare questo elemento?',
  },
}
